import IframeContainer from "./IframeContainer";

const renderVimeo = (uri: string) => {
  return (
    <IframeContainer>
      <iframe title="Vimeo" src={uri} style={{ border: "none" }} allowFullScreen></iframe>
    </IframeContainer>
  );
};

export const vimeoRenderer = {
  renderVimeo,
};
